import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.41 12h19.8M11.31 21.9V2.1",
		stroke: "#fff",
		strokeWidth: 2
	})
});
export default SvgPlus;
